import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ActiveCompanies from './components/ActiveCompanies'


const ActiveCompaniesTable = (props) => (

    <Container>
        <ActiveCompanies {...props} />
    </Container>
);

ActiveCompaniesTable.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ActiveCompaniesTable);

